import styled from 'styled-components';

export const CheckboxText = styled.span`
	${({ theme }) => theme.fonts.text.text5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const Checkboxes = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.large};
`;

export const ExternalLink = styled.a`
	color: ${({ theme }) => theme.colors.text.brand.enabled};
`;
